if (!customElements.get('scroll-to-top')) {
  customElements.define(
    'scroll-to-top',
    class ScrollToTop extends HTMLElement {
      constructor() {
        super();
        this.scrollButton = this.querySelector('.scroll-to-top-arrow');
        this.threshold = window.innerHeight; // Show after scrolling one viewport height
      }

      connectedCallback() {
        this.handleScroll = this.handleScroll.bind(this);
        window.addEventListener('scroll', this.handleScroll);
        
        // Initial check
        this.handleScroll();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.handleScroll);
      }

      handleScroll() {
        const scrolled = window.pageYOffset || document.documentElement.scrollTop;
        
        if (scrolled > this.threshold) {
          this.scrollButton.classList.add('scroll-to-top-arrow--visible');
        } else {
          this.scrollButton.classList.remove('scroll-to-top-arrow--visible');
        }
      }
    }
  );
}
